/* sst-collection-page.js */
(function () {
  'use strict';

  // --- Mobile filter drawer ---
  document.querySelectorAll('[data-coll-drawer]').forEach(function (drawer) {
    drawer.querySelectorAll('[data-coll-drawer-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        drawer.removeAttribute('open');
      });
    });

    drawer.addEventListener('toggle', function () {
      document.documentElement.classList.toggle('sst-coll-drawer-open', drawer.open);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-coll-drawer][open]').forEach(function (drawer) {
      drawer.removeAttribute('open');
    });
  });

  // --- Filtering: navigate to the filtered URL built from the facet form ---
  function applyFacetForm(form) {
    var params = new URLSearchParams(new FormData(form));
    // Drop empty values so we don't append blank price fields, etc.
    var clean = new URLSearchParams();
    params.forEach(function (value, key) {
      if (value !== '') clean.append(key, value);
    });
    var query = clean.toString();
    window.location.href = window.location.pathname + (query ? '?' + query : '');
  }

  document.querySelectorAll('[data-coll-facet-form]').forEach(function (form) {
    form.addEventListener('change', function (event) {
      // Price inputs commit on change/blur; checkboxes commit immediately.
      if (event.target.matches('input[type="number"], input[type="checkbox"]')) {
        applyFacetForm(form);
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      applyFacetForm(form);
    });
  });

  // --- Sort dropdown ---
  document.querySelectorAll('[data-coll-sort]').forEach(function (select) {
    var defaultSort = select.getAttribute('data-default-sort');
    var params = new URLSearchParams(window.location.search);

    if (defaultSort && !params.has('sort_by')) {
      var hasDefaultSort = Array.prototype.some.call(select.options, function (option) {
        return option.value === defaultSort;
      });

      if (hasDefaultSort) {
        params.set('sort_by', defaultSort);
        params.delete('page');
        window.location.replace(window.location.pathname + '?' + params.toString());
        return;
      }
    }

    select.addEventListener('change', function () {
      params = new URLSearchParams(window.location.search);
      params.set('sort_by', select.value);
      params.delete('page');
      window.location.href = window.location.pathname + '?' + params.toString();
    });
  });
})();
